export default __webpack_public_path__ + "static/media/citizen-monitor.2c2a0e59.png";